export const defaultPermissions = {
    group: { read: true, write: false },
    other: { read: false, write: false },
    user: { read: true, write: true },
};
